<div class="page pt-2 pt-md-4">
    <div class="content-container extended">
        <div class="-ps-5 side-container mb-3">
            <div class="pt-0 position-relative">
                <pla-side-nav></pla-side-nav>
            </div>
        </div>
        <div class="center-content-container position-relative">
            <div class="pla_card mobile spacing no-top no-card no-left no-right position-relative">
                <!-- BREADCRUMBS -->
                <div class="w-100">
                    <div
                        class="border-bottom d-flex align-items-center justify-content-start gap-2 w-100 px-3 px-lg-0 pb-2 pt-0">
                        <a style="color: #327b8d" class="d-block text-decoration-none" [routerLink]="['/']">Home</a>
                        <span>/</span>
                        <span style="color: #939393; white-space: pre" class="text-decoration-none d-block">Guides</span>
                    </div>
                </div>
            </div>

            <div class="pla_card mobile spacing no-top no-card no-left no-right position-relative px-0 px-md-1 py-0 me-0">
                <div class="mx-3 mx-md-2">
                    <div class="mt-4 mb-4 border-bottom border-2" style="border-color: #3791A8 !important;">
                        <h1 class="fs-mb-16 fs-md-18 fw-bold text-start mx-0 mb-3 lh-base">Number Plate Guides</h1>
                    </div>
                    <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">
                        Everything you need to know about UK registrations: the different plate formats, what makes a
                        plate cherished, and how to transfer, retain and buy a private number plate for less.
                    </p>
                    <ul class="guide-list list-unstyled mb-5">
                        <li *ngFor="let guide of guides" class="mb-3 pb-3 border-bottom">
                            <a class="fs-md-16 fs-mb-16 fw-bold text-decoration-none d-block mb-1" style="color: #327b8d"
                                [routerLink]="['/guides', guide.slug]">{{ guide.name }}</a>
                            <p class="fs-md-14 fs-mb-14 text-dark mb-0">{{ guide.summary }}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
